import { render, staticRenderFns } from "./receiptsList.vue?vue&type=template&id=2451807e&scoped=true&"
import script from "./receiptsList.vue?vue&type=script&lang=js&"
export * from "./receiptsList.vue?vue&type=script&lang=js&"
import style0 from "./receiptsList.vue?vue&type=style&index=0&id=2451807e&lang=scss&scoped=true&"
import style1 from "./receiptsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451807e",
  null
  
)

export default component.exports